
    import { defineComponent} from 'vue';

    import GetLanguage from '@/tools/language';
    import GeneralFx from '@/tools/general_fx';

    import NetServices from '@/tools/netservices';
    import { ProdCategory } from '@/models/producttypes';

    const language =GetLanguage(),
        appFxs = GeneralFx();
    
    const emptyCategory: ProdCategory = {
        ProdCategoryId: 0,
        Code: '',
        NameEn: '',
        NameFr: '',
        NameRw: '',
        Description: '',
    };
    export default defineComponent({
        name: 'ProdCategModal',
        emits: ['closeForm'],
        props: ["visible", "initialValues", "recordStatus"],
        data(){
            return {
                language,
                appFxs,
                dataRecord: { ...emptyCategory } as ProdCategory,
                isSavingRecord: false,
            }
        },
        computed: {        
            windowTitle():string {
                return this.recordStatus === 0 ? language.new_categ:
                language.edit_categ;
            },
            validationRules(){                
                const codeErrorValid = !this.dataRecord.Code;
                const codeErrorMsg = [] as string[];
                if(codeErrorValid) codeErrorMsg.push(language.fldRequired);

                
                const nameEnErrorValid = !this.dataRecord.NameEn;
                const nameEnErrorMsg = [] as string[];
                if(nameEnErrorValid) nameEnErrorMsg.push(language.fldRequired);

                const NameFrErrorValid = !this.dataRecord.NameFr;
                const NameFrErrorMsg = [] as string[];
                if (NameFrErrorValid) NameFrErrorMsg.push(language.fldRequired);

                const NameRwErrorValid = !this.dataRecord.NameRw;
                const NameRwErrorMsg = [] as string[];
                if (NameRwErrorValid) NameRwErrorMsg.push(language.fldRequired);


                const formInvalid = NameFrErrorValid || nameEnErrorValid || NameFrErrorValid || NameRwErrorValid;

                return {
                    $invalid: formInvalid,
                    fields: {
                        Code: {
                            $error: codeErrorMsg,
                            $errors: codeErrorMsg
                        },
                        NameEn: {
                            $error: nameEnErrorValid,
                            $errors: nameEnErrorMsg
                        },
                        NameFr: {
                            $error: NameFrErrorValid,
                            $errors: NameFrErrorMsg
                        },
                        NameRw: {
                            $error: NameRwErrorValid,
                            $errors:NameRwErrorMsg
                        },
                    }
                }
            }
        },
        methods: {
            selectOnFocus(evt: Event) {
                const oInput = evt.target as HTMLInputElement;
                oInput.select();
            },
            saveNewCategory() {
                this.isSavingRecord = true;
                const initRec = appFxs.getProxyData(this.dataRecord) as ProdCategory;
                const fRecord = { ...initRec, Code: initRec.Code.toUpperCase()  };
                
                NetServices.requestPost('products/categs/saveprodcategory', {
                    prodCategoryRecord: fRecord,
                    toDelete: false,
                }).then(oRes => {
                    if (!oRes.bReturn) {
                        appFxs.showAlert(oRes.msgTitle, oRes.msgBody);
                        this.isSavingRecord = false;
                        return;
                    }

                    const fList: ProdCategory[] = [];
                    oRes.listOfProdCategories!.forEach(oEmail => {
                        const fEmail = { ...oEmail }
                        fList.push(fEmail);
                    });

                    this.isSavingRecord = false;
                    this.$emit('closeForm', {returnType: 1, returnData: {bReturn: true, listOfCategories: fList}});
                });
            },            
            closeFormRet(){
                this.$emit('closeForm', {returnType: 0, returnData: null});
            },
        },
        watch:{
            visible: {
                handler(newV, oldV){
                    if((newV) && newV !== oldV ){
                        const oValues = appFxs.getProxyData(this.initialValues);
                        const fValues: ProdCategory = {...oValues};                       

                        this.dataRecord = fValues;
                    }
                }
            }
        }
        
        
    })
